var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#001E3C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.524 4.385H2.476A.47.47 0 0 0 2 4.86v14.467c0 .266.21.476.476.476h19.048c.266 0 .476-.21.476-.476V4.86a.47.47 0 0 0-.476-.476m-.476 14.466H2.952V5.337h18.096z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.505 16.766a.462.462 0 0 0 .667 0l3.961-3.962 1.496 1.495a.462.462 0 0 0 .667 0l1.533-1.524 4 3.99a.462.462 0 0 0 .667 0 .47.47 0 0 0 0-.676l-4-3.99 4-4a.47.47 0 0 0 0-.676.47.47 0 0 0-.677 0l-4.333 4.333-1.534 1.524-5.79-5.79a.47.47 0 0 0-.676 0 .47.47 0 0 0 0 .676l3.962 3.962-3.962 3.961a.47.47 0 0 0 0 .677z"
}))));
export { SvgEmail as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNTE3YWVhMTQwYzI1NWFlOGMwMzZmNTUyODEzN2Y1ODMuc3ZnIjs=";